// src/pages/organization/team/ShowMember.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import ProfilePicture, { default as ProfileImage } from "../../../components/profileImage";
import { useMainPageTitle } from "../../../contexts/PageContext";
import Popup from "../../../components/popup";
const API_URL = "https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1";


const ShowMember = () => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [team, setTeam] = useState(null);
  const { memberId, teamId } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { updatePageTitle } = useMainPageTitle();
  const [isUnassignPopupOpen, setIsUnassignPopupOpen] = useState(false);
  
  useEffect(() => {
    const fetchMemberData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${API_URL}/team/show-supervisor/?supervisorId=${memberId}&teamId=${teamId}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setMember(data.supervisor);
        setTeam(data.team);
        console.log("API Response data:", data);
        console.log("Member metaData:", data.supervisor?.metaData);
        console.log("Teams in metaData:", data.supervisor?.metaData?.teams);
        setLoading(false);
      } catch (err) {
        setError("Failed to load member data");
        setLoading(false);
        console.error("Error fetching member data:", err);
      }
    };

    fetchMemberData();
  }, [memberId, token, teamId]);

  useEffect(() => {
    if (member) {
      updatePageTitle("Show a member", `${member.firstName} ${member.lastName}`);
    }
  }, [updatePageTitle, member]);

  const handleEditSupervisor = () => {
    navigate(`/organization/team/assign-supervisor-edit/${memberId}/${teamId}`);
  };

  const handleUnassignSupervisor = async () => {
    try {
      const response = await fetch(
        `${API_URL}/team/unassign-supervisor-from-team/?teamId=${teamId}&supervisorId=${memberId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Close popup and navigate back to team page after successful unassign
      setIsUnassignPopupOpen(false);
      navigate(`/organization/team/${teamId}`);
    } catch (err) {
      console.error("Error unassigning supervisor:", err);
      setError("Failed to unassign supervisor");
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center">
          <div className="rounded-full bg-gray-200 h-24 w-24 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-48 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-32"></div>
        </div>
      </div>
    );

  if (error)
    return (
      <div className="flex items-center justify-center">
        <div className="bg-red-50 border-l-4 border-red-500 p-4 w-full max-w-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          </div>
        </div>
      </div>
    );

  if (!member)
    return (
      <div className="flex items-center justify-center">
        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 w-full max-w-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-yellow-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-yellow-700">Member not found</p>
            </div>
          </div>
        </div>
      </div>
    );

  // The API returns team-specific info in currentTeam when teamId is provided
  const teamData = member.currentTeam ? {
    title: member.currentTeam.supervisorTitle,
    role: member.currentTeam.supervisorRole,
    joinedAt: member.currentTeam.joinedAt,
    teamId: teamId
  } : null;
  
  console.log("Current teamId:", teamId);
  console.log("Found teamData:", teamData);
  console.log("Member currentTeam:", member.currentTeam);
  console.log("Member structure:", member);

  return (
    <div className="py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main content */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          {/* Header with background */}
          <div className="bg-gradient-to-r from-[#F15213] to-[#F15213] px-6 py-16 relative">
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
              <div className="">
                <ProfilePicture
                image={member.profilePicture}
                alt={`${member.firstName} ${member.lastName}`}
                className="rounded-full object-cover w-20 h-20"
                myUser={member}
              />
              </div>
            </div>
          </div>

          {/* Profile info */}
          <div className="pt-16 px-6 pb-6 text-center">
            <h1 className="text-2xl font-bold text-gray-900">
              {member.firstName} {member.lastName}
            </h1>
            <p className="text-gray-500">@{member.userName}</p>
            <p className="mt-1 text-sm text-gray-600">{member.accountType}</p>

            {member.accountType === "supervisor" && (
              <div className="mt-4 space-x-4">
                <button
                  className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  onClick={handleEditSupervisor}
                >
                  <svg
                    className="-ml-1 mr-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                  </svg>
                  Edit Supervisor Role
                </button>

                <Link
                  to={`/chat/${member._id}`}
                  className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#F15213] hover:bg-[#d14510] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F15213] transition-colors"
                >
                  <svg
                    className="-ml-1 mr-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Chat
                </Link>

                <button
                  className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                  onClick={() => setIsUnassignPopupOpen(true)}
                >
                  <svg
                    className="-ml-1 mr-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Unassign Supervisor
                </button>
              </div>
            )}
          </div>

          {/* Contact info */}
          <div className="border-t border-gray-200 px-6 py-5">
            <h2 className="text-lg font-medium text-gray-900 mb-4">
              Contact Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center">
                <svg
                  className="h-5 w-5 text-gray-400 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span className="text-gray-900">{member.email}</span>
              </div>
              <div className="flex items-center">
                <svg
                  className="h-5 w-5 text-gray-400 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span className="text-gray-900">
                  {member.phone || "Not provided"}
                </span>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">Title</h3>
                <p className="mt-1 text-gray-900">{teamData?.title || "Not specified"}</p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">Joined</h3>
                <p className="mt-1 text-gray-900">
                  {teamData?.joinedAt ? new Date(teamData.joinedAt).toLocaleDateString() : "Not available"}
                </p>
              </div>
            </div>
          </div>

          {/* Team info */}
          {teamData && (
            <div className="border-t border-gray-200 px-6 py-5">
              <h2 className="text-lg font-medium text-gray-900 mb-4">
                Team Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <ProfileImage
                    image={team.logo}
                    alt={team.name}
                    className="w-24 h-24 rounded-xl object-cover border-2 border-gray-100"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-500">Name</h3>
                  <p className="mt-1 text-gray-900">{team.name}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-500">
                    Unique Name
                  </h3>
                  <p className="mt-1 text-gray-900">{team.uniqueName}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-500">Type</h3>
                  <p className="mt-1 text-gray-900">{team.type}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-500">Gender</h3>
                  <p className="mt-1 text-gray-900">{team.gender}</p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-500">Sport</h3>
                  <p className="mt-1 text-gray-900">{team.sport}</p>
                </div>
              </div>
            </div>
          )}

          {/* Role permissions */}
          {teamData && (
            <div className="border-t border-gray-200 px-6 py-5">
              <h2 className="text-lg font-medium text-gray-900 mb-4">
                Role Permissions
              </h2>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Feature
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Create
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Read
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Update
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Delete
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {teamData?.role && Object.entries(teamData.role).map(
                      ([feature, permissions], index) => (
                        <tr
                          key={feature}
                          className={
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">
                            {feature}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {permissions.create ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Allowed
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                Denied
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {permissions.read !== undefined ? (
                              permissions.read ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  Allowed
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  Denied
                                </span>
                              )
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                N/A
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {permissions.update ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Allowed
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                Denied
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {permissions.delete ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Allowed
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                Denied
                              </span>
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      <Popup
        isOpen={isUnassignPopupOpen}
        onClose={() => setIsUnassignPopupOpen(false)}
        onConfirm={handleUnassignSupervisor}
        message={`Are you sure you want to unassign ${member?.firstName} ${member?.lastName} as supervisor?`}
      />
    </div>
  );
};

export default ShowMember;
